'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

function gtmScriptPresent(gtmId: string) {
  return !!document.querySelector(
    `script[src^="https://www.googletagmanager.com/gtm.js?id=${gtmId}"]`,
  );
}

export default function GTMHealthMonitor() {
  const pathname = usePathname();

  useEffect(() => {
    const criticalPages = [
      '/checkout',
      '/siparis-alindi',
      '/order',
      '/payment-callback',
      '/satin-al',
    ];
    const isCriticalPage = criticalPages.some((page) => pathname.includes(page));

    if (!isCriticalPage) return;

    const checkGTMHealth = () => {
      if (typeof window === 'undefined') return;

      const gtmId = process.env.NEXT_PUBLIC_GTM_ID;
      if (!gtmId) return;

      const hasGTM = !!window.gtm_loaded || gtmScriptPresent(gtmId);
      if (hasGTM) {
        window.gtm_loaded = true;
        return;
      }

      console.warn('🔴 GTM connection lost on critical page');

      window.dataLayer = window.dataLayer || [];
      window.gtag = function () {
        window.dataLayer = window.dataLayer || [];
        // eslint-disable-next-line prefer-rest-params
        window.dataLayer.push(arguments);
      };

      window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
      script.onload = () => {
        window.gtm_loaded = true;
      };
      document.head.appendChild(script);
    };

    checkGTMHealth();
  }, [pathname]);

  return null;
}
